import { Controller } from 'react-hook-form'
import HtmlPrintBox from '../../../admin/common/HtmlPrintBox'
import ReactQuill from 'react-quill-new'
import { reactQuillFormats, reactQuillModules } from '../../../../utils/editor/reactQuill'

const AdditionalComments = ({ register, control, isRead = false }) => {
    return (
        <div>
            <Controller
                name={`additionalComments`}
                control={control}
                render={({ field }) => (
                    isRead
                        ? <div style={{ overflowX: "auto", border: "1px solid #888" }}>
                            <div style={{ width: "900px", padding: '20px', fontSize: "15px" }}>
                                <HtmlPrintBox value={field.value} />
                            </div>
                        </div>
                        : <ReactQuill
                            theme="snow"
                            value={field.value}
                            onChange={field.onChange}
                            modules={reactQuillModules}
                            formats={reactQuillFormats}
                            style={{ height: '300px', marginBottom: '80px' }}
                        />
                )}
            />
        </div>
    )
}

export default AdditionalComments